/* eslint-disable import/prefer-default-export */
export const GOOGLE_CLIENT_ID =
  "516047975643-vhius5e59h4tqb87qlan95t0prvbshbt.apps.googleusercontent.com";
